import React from 'react';

import TestimonialCard from 'ui-brand/components/TestimonialCard';
import Logo4camping from 'ui-brand/img/eshop-logos/4camping.svg';
import LogoAstratex from 'ui-brand/img/eshop-logos/astratex.svg';
import LogoGrizly from 'ui-brand/img/eshop-logos/grizly.svg';
import LogoKnihyDobrovsky from 'ui-brand/img/eshop-logos/knihy-dobrovsky.svg';
import LogoGrizlyColor from 'ui-brand/img/eshop-logos/testimonials/grizly_barevne.svg';
import LogoOlivieColor from 'ui-brand/img/eshop-logos/testimonials/olivie_barevne_logo.svg';
import LogoScontoColor from 'ui-brand/img/eshop-logos/testimonials/sconto_barevne.svg';
import LogoVikioColor from 'ui-brand/img/eshop-logos/testimonials/vikio_logo_cerne.svg';
import LogoVuch from 'ui-brand/img/eshop-logos/vuch.svg';

const LOGOS = [
  { src: LogoAstratex, alt: 'Astratex' },
  { src: LogoVuch, alt: 'VUCH' },
  { src: LogoKnihyDobrovsky, alt: 'Knihy Dobrovský' },
  { src: LogoGrizly, alt: 'Grizly' },
  { src: Logo4camping, alt: '4camping' },
];

const TESTIMONIALS = [
  {
    quote: gettext('“Retino has sped up our claims handling significantly and our customers rate it highly.”'),
    name: 'Petr Miklík',
    role: 'CMO, Grizly',
    logo: <img src={LogoGrizlyColor} alt="Grizly" />,
  },
  {
    quote: gettext('“Rolling Retino out in our company was simple and fast.”'),
    name: 'Ondřej Beneš',
    role: 'Manager of CX, SCONTO Nábytek',
    logo: <img src={LogoScontoColor} alt="SCONTO Nábytek" />,
  },
  {
    quote: gettext('“Thanks to Retino Tracking we have access to data most stores do not have.”'),
    name: 'Lukáš Sluka',
    role: 'CEO, Olivie',
    logo: <img src={LogoOlivieColor} alt="Olivie" />,
  },
  {
    quote: gettext('“Retino is a real asset for us, we have an overview of every case.”'),
    name: 'Jiří Kuneš',
    role: 'CEO, Vikio',
    logo: <img src={LogoVikioColor} alt="Vikio" />,
  },
];

function SocialProofPanel() {
  return (
    <section>
      <h2 className="text-base font-semibold uppercase leading-snug tracking-wide text-retino-darkviolet">
        {gettext('Join 2 000+ stores that use Retino')}
      </h2>
      <ul className="mt-6 flex flex-wrap items-center justify-between gap-4">
        {LOGOS.map((logo) => (
          <li key={logo.alt}>
            <img src={logo.src} alt={logo.alt} className="h-5 w-auto lg:h-6" />
          </li>
        ))}
      </ul>
      <div className="mt-8 grid gap-4 md:grid-cols-2">
        {TESTIMONIALS.map((testimonial) => (
          <TestimonialCard key={testimonial.name} {...testimonial} />
        ))}
      </div>
    </section>
  );
}

export default SocialProofPanel;
